export enum UnitStatus {
    New = 'new',
    Passed = 'passed',
    Failed = 'failed',
}